import { Injectable, signal } from '@angular/core';

/**
 * Cognito token store, modeled on the admin-portal-ui AuthService.
 * The idToken is what we send as `Authorization: Bearer <idToken>` (via the
 * interceptor). Tokens come from the attendee login (OTP verify) endpoint.
 */
const ID_TOKEN_KEY = 'auth_token';
const ACCESS_TOKEN_KEY = 'access_token';

function readToken(type: 'id' | 'access'): string | null {
  try {
    return localStorage.getItem(
      type === 'id' ? ID_TOKEN_KEY : ACCESS_TOKEN_KEY
    );
  } catch {
    return null;
  }
}

const _authed = signal<boolean>(!!readToken('id'));

@Injectable({ providedIn: 'root' })
export class AuthService {
  public readonly isAuthed = _authed.asReadonly();

  getToken(type: 'id' | 'access'): string | null {
    return readToken(type);
  }

  setTokens(idToken: string, accessToken: string): void {
    try {
      localStorage.setItem(ID_TOKEN_KEY, idToken);
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    } catch {
      /* storage unavailable */
    }
    _authed.set(true);
  }

  clear(): void {
    try {
      localStorage.removeItem(ID_TOKEN_KEY);
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    } catch {
      /* ignore */
    }
    _authed.set(false);
  }
}
